import Button from "../../../Components/Button";
import DatePicker from "../../../Components/DatePicker";
import { IChartCommonSearchParam } from "../../../Interfaces/optionDomain";

interface IProps {
  searchParams: IChartCommonSearchParam;
  onChange: (name: string, value: any) => void;
  onSubmit: () => void;
}

const ChartSearchParamUI = ({ onChange, searchParams, onSubmit }: IProps) => {
  return (
    <div className="flex flex-col justify-start items-start gap-3">
      <DatePicker
        label="از تاریخ"
        name="fromDate"
        onChange={onChange}
        value={searchParams.fromDate}
      />
      <DatePicker
        label="تا تاریخ"
        name="toDate"
        onChange={onChange}
        value={searchParams.toDate}
      />
      <Button text="جستجو" onClick={onSubmit} variant="contained" />
    </div>
  );
};

export default ChartSearchParamUI;
